export default __webpack_public_path__ + "static/media/aaditya.17ee1a0a.png";